export default "__VITE_ASSET__C$20EaMY__"